// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/Assets/Feeds/backgroundImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.OrdersPage,
.QuotesPage,
.CustomerOrderDetailPage,
.CreateOfferingPage,
.EditOfferingPage,
.OfferingsDashboardPage,
.OfferingDetailPage,
.MarketplacePage,
.RequestQuotePage,
.QuoteDetailPage,
.EventDashboardPage,
.ProviderProfilePage,
.ProviderReviewsPage,
.PayoutSettingsPage {
  width: 100%;
  min-height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #071414;
  color: #ffffff;
  font-family: "Inter", sans-serif;
}

.adventurePageContainer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* ── Shared header container (z-index) ── */
.headerContain {
  z-index: 100000;
}

/* ── Shared body row ── */
.adventurePageContainer2 {
  display: flex;
  width: 100%;
  min-height: calc(100vh - 12vh);
  position: relative;
}

/* ── Shared sidebar ── */
.sidebarContain {
  position: fixed;
  left: 0;
  top: 0;
  width: 20%;
  height: 100vh;
  background-color: rgba(14, 27, 27, 0.95);
  padding-top: 15vh;
  z-index: 1000;
  overflow-y: auto;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.sidebarContain::-webkit-scrollbar { width: 6px; }
.sidebarContain::-webkit-scrollbar-track { background: transparent; }
.sidebarContain::-webkit-scrollbar-thumb { background-color: rgba(255,255,255,0.3); border-radius: 3px; }
.sidebarContain::-webkit-scrollbar-thumb:hover { background-color: rgba(255,255,255,0.5); }

/* ── Main content area ── */
.adv-page-main {
  margin-left: 22%;
  margin-right: 2%;
  margin-top: 14vh;
  margin-bottom: 3vh;
  min-height: calc(100vh - 15vh);
  width: 76%;
  z-index: 1000;
  box-sizing: border-box;
  padding: 0 0.5vw;
}

/* ─────────────────────────────────────────────────────
   PAGE HEADER TEXT
───────────────────────────────────────────────────── */

.adv-page-header {
  margin-bottom: 24px;
}

.adv-page-title {
  font-family: "Inter", sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px 0;
  line-height: normal;
}

.adv-page-title-accent {
  color: #48d1cc;
}

.adv-page-sub {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #777;
  margin: 0;
  line-height: normal;
}

/* ─────────────────────────────────────────────────────
   FILTER TABS
───────────────────────────────────────────────────── */

.adv-filter-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  padding-bottom: 10px;
  flex-wrap: wrap;
}

.adv-filter-tab {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  padding: 7px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  color: #777;
  cursor: pointer;
  text-transform: capitalize;
  transition: all 0.2s ease;
}

.adv-filter-tab:hover {
  color: #fff;
  background: rgba(255,255,255,0.04);
}

.adv-filter-tab--active {
  background-color: #3bb3ae;
  color: #071414;
  font-weight: 700;
}

/* ─────────────────────────────────────────────────────
   STATUS BADGES
───────────────────────────────────────────────────── */

.adv-status {
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  padding: 3px 10px;
  border-radius: 20px;
  line-height: normal;
}

.adv-status--confirmed   { color: #48d1cc; background: rgba(72,209,204,0.12); }
.adv-status--pending     { color: #f5c842; background: rgba(245,200,66,0.12); }
.adv-status--in_progress { color: #ffd700; background: rgba(255,215,0,0.12); }
.adv-status--completed   { color: #28a745; background: rgba(40,167,69,0.12); }
.adv-status--cancelled   { color: #dc3545; background: rgba(220,53,69,0.12); }
.adv-status--closed      { color: #20b2aa; background: rgba(32,178,170,0.12); }
.adv-status--disputed    { color: #ff4500; background: rgba(255,69,0,0.12); }
.adv-status--registered   { color: #48d1cc; background: rgba(72,209,204,0.12); }
.adv-status--waitlisted   { color: #f5c842; background: rgba(245,200,66,0.12); }


/* ─────────────────────────────────────────────────────
   LIST & BOOKING CARDS (CustomerBookingsPage)
───────────────────────────────────────────────────── */

.adv-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.adv-booking-card {
  display: flex;
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  overflow: hidden;
  padding: 16px;
  gap: 16px;
  align-items: center;
  transition: border-color 0.2s ease;
}

.adv-booking-card:hover {
  border-color: rgba(59, 179, 174, 0.3);
}

.adv-booking-card__img {
  width: 96px;
  height: 96px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.adv-booking-card__body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.adv-booking-card__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.adv-booking-card__name {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
  line-height: normal;
}

.adv-booking-card__meta {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #777;
  margin: 2px 0;
  line-height: normal;
}

.adv-booking-card__meta strong {
  color: #ffffff;
  font-weight: 500;
}

.adv-booking-card__price {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #48d1cc;
  margin-top: 6px;
  line-height: normal;
}

.adv-booking-card__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 130px;
  flex-shrink: 0;
}

/* ─────────────────────────────────────────────────────
   REQUEST CARDS (ProviderBookingsInboxPage)
───────────────────────────────────────────────────── */

.adv-request-card {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: border-color 0.2s ease;
}

.adv-request-card:hover {
  border-color: rgba(59, 179, 174, 0.3);
}

.adv-request-card__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.adv-request-card__customer {
  display: flex;
  gap: 12px;
  align-items: center;
}

.adv-request-card__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.adv-request-card__name {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  margin: 0 0 2px 0;
  line-height: normal;
}

.adv-request-card__time {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #777;
  line-height: normal;
}

.adv-request-card__detail-grid {
  display: grid;
  grid-template-columns: 1.8fr 1.2fr;
  gap: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 16px;
}

.adv-request-card__left-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.adv-request-card__meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.adv-meta-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: rgba(90, 175, 154, 0.08);
  border: 1px solid rgba(90, 175, 154, 0.15);
  padding: 6px 12px;
  border-radius: 20px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #5AAF9A;
}

.adv-meta-pill span {
  font-size: 13px;
}

.adv-request-card__right-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  text-align: right;
  min-height: 120px;
}

.adv-request-card__price-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.adv-price-title {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.adv-price-val {
  font-size: 24px;
  font-weight: 700;
  color: #5AAF9A;
}

.adv-request-card__actions-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;
  margin-top: auto;
}

/* ─────────────────────────────────────────────────────
   DETAIL LABELS & TYPOGRAPHY
───────────────────────────────────────────────────── */

.adv-detail-label {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #777;
  margin: 0 0 4px 0;
  line-height: normal;
}

.adv-detail-value {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  line-height: normal;
}

.adv-detail-sub {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #777;
  margin: 2px 0 0 0;
  line-height: normal;
}

.adv-detail-link {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #48d1cc;
  cursor: pointer;
  text-decoration: underline;
  line-height: normal;
}

.adv-detail-notes {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #777;
  background: rgba(0,0,0,0.15);
  padding: 10px;
  border-radius: 6px;
  margin: 0;
  line-height: 1.5;
}

/* ─────────────────────────────────────────────────────
   DETAIL PAGE LAYOUT (CustomerBookingDetailPage)
───────────────────────────────────────────────────── */

.adv-detail-page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.adv-detail-grid {
  display: grid;
  grid-template-columns: 1.8fr 1.2fr;
  gap: 24px;
}

.adv-detail-left,
.adv-detail-right {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Cards used in detail page ── */
.adv-card {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 20px;
}

.adv-card--row {
  display: flex;
  gap: 16px;
  align-items: center;
}

.adv-card--col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.adv-card-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.adv-card-title {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 14px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255,255,255,0.07);
  line-height: normal;
}

.adv-detail-cover {
  width: 100%;
  height: 220px;
  border-radius: 8px;
  object-fit: cover;
  margin-bottom: 16px;
}

.adv-detail-title {
  font-family: "Inter", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 10px 0;
  line-height: normal;
}

.adv-detail-meta-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.adv-detail-date-note {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #777;
  line-height: normal;
}

/* ── Notes blocks ── */
.adv-note-block {
  background: rgba(0,0,0,0.2);
  padding: 12px;
  border-radius: 6px;
}

.adv-note-block--teal  { background: rgba(72,209,204,0.06); border: 1px solid rgba(72,209,204,0.15); }
.adv-note-block--green { background: rgba(40,167,69,0.06); border: 1px solid rgba(40,167,69,0.15); }
.adv-note-block--red   { background: rgba(255,107,107,0.06); border: 1px solid rgba(255,107,107,0.15); }
.adv-note-block--yellow { background: rgba(255,215,0,0.06); border: 1px solid rgba(255,215,0,0.15); }

.adv-note-text {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #ffffff;
  margin: 0;
  line-height: 1.5;
}

/* ── Schedule rows ── */
.adv-schedule-rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adv-schedule-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.adv-schedule-divider {
  border-top: 1px solid rgba(255,255,255,0.08);
  margin: 4px 0;
}

.adv-schedule-price {
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #48d1cc;
  line-height: normal;
}

.adv-action-btns {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adv-btn--full { width: 100%; }

.adv-waiting-note {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #777;
  text-align: center;
  background: rgba(255,255,255,0.03);
  padding: 10px;
  border-radius: 8px;
  border: 1.5px solid rgba(255,255,255,0.07);
}

.adv-auto-release-note {
  font-family: "Inter", sans-serif;
  font-size: 11px;
  color: #777;
  text-align: center;
  font-style: italic;
  margin: 0;
}

/* ── Timeline ── */
.adv-timeline {
  position: relative;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.adv-timeline__track {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 4px;
  width: 2px;
  background-color: rgba(255,255,255,0.1);
}

.adv-timeline__item {
  position: relative;
}

.adv-timeline__dot {
  position: absolute;
  left: -20px;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.adv-timeline__content {
  display: flex;
  flex-direction: column;
}

.adv-timeline__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.adv-timeline__status {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  text-transform: capitalize;
  line-height: normal;
}

.adv-timeline__actor {
  font-family: "Inter", sans-serif;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(255,255,255,0.06);
  color: #777;
  text-transform: uppercase;
}

.adv-timeline__time {
  font-family: "Inter", sans-serif;
  font-size: 11px;
  color: #777;
  margin-top: 2px;
}

.adv-timeline__note {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #777;
  margin-top: 4px;
}

/* ── Evidence grid ── */
.adv-evidence-grid {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.adv-evidence-img {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid rgba(255,255,255,0.1);
}

.adv-evidence-remove {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #dc3545;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* ─────────────────────────────────────────────────────
   BUTTONS (shared)
───────────────────────────────────────────────────── */

.adv-btn-primary {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background-color: #3bb3ae;
  color: #071414;
  cursor: pointer;
  transition: opacity 0.2s;
  white-space: nowrap;
  line-height: normal;
}
.adv-btn-primary:hover { opacity: 0.88; }

.adv-btn-outline {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #484848;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;
  line-height: normal;
}
.adv-btn-outline:hover { border-color: #48d1cc; color: #48d1cc; }

.adv-btn-teal-outline {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #48d1cc;
  background: transparent;
  color: #48d1cc;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
  line-height: normal;
}
.adv-btn-teal-outline:hover { background: rgba(72,209,204,0.08); }

.adv-btn-danger-outline {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(255,107,107,0.4);
  background: transparent;
  color: #ff6b6b;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
  line-height: normal;
}
.adv-btn-danger-outline:hover { background: rgba(255,107,107,0.08); }

.adv-btn-success {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background-color: #28a745;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s;
  white-space: nowrap;
  line-height: normal;
}
.adv-btn-success:hover { opacity: 0.88; }

.adv-btn-destructive {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background-color: #dc3545;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s;
  white-space: nowrap;
  line-height: normal;
}
.adv-btn-destructive:hover { opacity: 0.88; }

.adv-btn-ghost {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: rgba(255,255,255,0.08);
  color: #ffffff;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
  line-height: normal;
}
.adv-btn-ghost:hover { background: rgba(255,255,255,0.12); }

/* ─────────────────────────────────────────────────────
   STATE MESSAGES
───────────────────────────────────────────────────── */

.adv-state-text {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #777;
  padding: 60px 0;
  text-align: center;
  line-height: normal;
}

.adv-state-error {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  color: #ff6b6b;
  padding: 40px;
  text-align: center;
  background: rgba(255,107,107,0.05);
  border: 1px solid rgba(255,107,107,0.15);
  border-radius: 12px;
}

.adv-empty {
  font-family: "Inter", sans-serif;
  background-color: #0e1b1b;
  border: 1.5px dashed rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.adv-empty p {
  font-size: 14px;
  font-weight: 400;
  color: #777;
  margin: 0;
  line-height: normal;
}

/* ─────────────────────────────────────────────────────
   MODALS
───────────────────────────────────────────────────── */

.adv-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 110000;
}

.adv-modal {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 24px;
  max-width: 420px;
  width: 100%;
  margin: 20px;
}

.adv-modal__title {
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  line-height: normal;
}

.adv-modal__desc {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #777;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

.adv-modal__field {
  margin-bottom: 16px;
}

.adv-modal__label {
  display: block;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #777;
  margin-bottom: 8px;
  line-height: normal;
}

.adv-modal__textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #484848;
  background-color: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  resize: none;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.adv-modal__textarea:focus {
  border-color: #3bb3ae;
}

.adv-modal__select {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #484848;
  background-color: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  color-scheme: dark;
}

.adv-modal__select:focus { border-color: #3bb3ae; }

.adv-modal__select option {
  background-color: #0e1b1b;
  color: #ffffff;
}

.adv-modal__input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #484848;
  background-color: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
  color-scheme: dark;
}

.adv-modal__input:focus {
  border-color: #3bb3ae;
}

.adv-modal__warning {
  font-family: "Inter", sans-serif;
  font-size: 11px;
  color: #ff6b6b;
  background: rgba(255,107,107,0.08);
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid rgba(255,107,107,0.15);
  line-height: 1.5;
}

.adv-modal__actions,
.adv-modal-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.adv-modal__char-count {
  display: block;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  color: #777;
  text-align: right;
  margin-top: 4px;
}

.adv-uploading-text {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #48d1cc;
}

/* ─────────────────────────────────────────────────────
   ANIMATION UTILITIES
───────────────────────────────────────────────────── */

@keyframes adv-fade-in {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.animate-fade-in {
  animation: adv-fade-in 0.3s ease forwards;
}

/* ─────────────────────────────────────────────────────
   RESPONSIVE
───────────────────────────────────────────────────── */

@media (max-width: 1024px) {
  .adv-detail-grid { grid-template-columns: 1fr; }
  .adv-request-card__detail-grid { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
  .adv-page-main {
    margin-left: 0;
    margin-right: 0;
    margin-top: 80px;
    width: 100%;
    padding: 0 16px;
  }

  .sidebarContain { display: none; }

  .adv-booking-card { flex-direction: column; align-items: flex-start; }
  .adv-booking-card__actions { width: 100%; flex-direction: row; flex-wrap: wrap; justify-content: flex-end; }
  .adv-detail-page-header { flex-direction: column; gap: 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/AdventureShared.css"],"names":[],"mappings":";AAKA;;;;;;;;;;;;;;EAcE,WAAW;EACX,iBAAiB;EACjB,yDAAoE;EACpE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,UAAU;EACV,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,iDAAiD;EACjD,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,uCAAuC,EAAE,kBAAkB,EAAE;AACxG,iDAAiD,uCAAuC,EAAE;;AAE1F,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;uDAEuD;;AAEvD;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;uDAEuD;;AAEvD;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,2BAA2B,cAAc,EAAE,iCAAiC,EAAE;AAC9E,2BAA2B,cAAc,EAAE,iCAAiC,EAAE;AAC9E,2BAA2B,cAAc,EAAE,gCAAgC,EAAE;AAC7E,2BAA2B,cAAc,EAAE,gCAAgC,EAAE;AAC7E,2BAA2B,cAAc,EAAE,gCAAgC,EAAE;AAC7E,2BAA2B,cAAc,EAAE,iCAAiC,EAAE;AAC9E,2BAA2B,cAAc,EAAE,+BAA+B,EAAE;AAC5E,4BAA4B,cAAc,EAAE,iCAAiC,EAAE;AAC/E,4BAA4B,cAAc,EAAE,iCAAiC,EAAE;;;AAG/E;;uDAEuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;uDAEuD;;AAEvD;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;uDAEuD;;AAEvD;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;AACpB;;AAEA,yBAAyB,iCAAiC,EAAE,uCAAuC,EAAE;AACrG,yBAAyB,gCAAgC,EAAE,sCAAsC,EAAE;AACnG,yBAAyB,kCAAkC,EAAE,wCAAwC,EAAE;AACvG,0BAA0B,gCAAgC,EAAE,sCAAsC,EAAE;;AAEpG;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB,WAAW,EAAE;;AAE9B;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;uDAEuD;;AAEvD;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,yBAAyB,aAAa,EAAE;;AAExC;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mDAAmD;EACnD,mBAAmB;EACnB,mBAAmB;AACrB;AACA,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;;AAEhE;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;AACA,8BAA8B,iCAAiC,EAAE;;AAEjE;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;AACA,gCAAgC,kCAAkC,EAAE;;AAEpE;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,yBAAyB,aAAa,EAAE;;AAExC;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,6BAA6B,aAAa,EAAE;;AAE5C;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;AACA,uBAAuB,kCAAkC,EAAE;;AAE3D;;uDAEuD;;AAEvD;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;;uDAEuD;;AAEvD;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,2BAA2B,qBAAqB,EAAE;;AAElD;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;;uDAEuD;;AAEvD;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;uDAEuD;;AAEvD;EACE,mBAAmB,0BAA0B,EAAE;EAC/C,iCAAiC,0BAA0B,EAAE;AAC/D;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA,kBAAkB,aAAa,EAAE;;EAEjC,oBAAoB,sBAAsB,EAAE,uBAAuB,EAAE;EACrE,6BAA6B,WAAW,EAAE,mBAAmB,EAAE,eAAe,EAAE,yBAAyB,EAAE;EAC3G,0BAA0B,sBAAsB,EAAE,SAAS,EAAE;AAC/D","sourcesContent":["\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n\n\n.OrdersPage,\n.QuotesPage,\n.CustomerOrderDetailPage,\n.CreateOfferingPage,\n.EditOfferingPage,\n.OfferingsDashboardPage,\n.OfferingDetailPage,\n.MarketplacePage,\n.RequestQuotePage,\n.QuoteDetailPage,\n.EventDashboardPage,\n.ProviderProfilePage,\n.ProviderReviewsPage,\n.PayoutSettingsPage {\n  width: 100%;\n  min-height: 100vh;\n  background-image: url(\"../../public/Assets/Feeds/backgroundImg.svg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #071414;\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n}\n\n.adventurePageContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* ── Shared header container (z-index) ── */\n.headerContain {\n  z-index: 100000;\n}\n\n/* ── Shared body row ── */\n.adventurePageContainer2 {\n  display: flex;\n  width: 100%;\n  min-height: calc(100vh - 12vh);\n  position: relative;\n}\n\n/* ── Shared sidebar ── */\n.sidebarContain {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 20%;\n  height: 100vh;\n  background-color: rgba(14, 27, 27, 0.95);\n  padding-top: 15vh;\n  z-index: 1000;\n  overflow-y: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n  box-sizing: border-box;\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n.sidebarContain::-webkit-scrollbar { width: 6px; }\n.sidebarContain::-webkit-scrollbar-track { background: transparent; }\n.sidebarContain::-webkit-scrollbar-thumb { background-color: rgba(255,255,255,0.3); border-radius: 3px; }\n.sidebarContain::-webkit-scrollbar-thumb:hover { background-color: rgba(255,255,255,0.5); }\n\n/* ── Main content area ── */\n.adv-page-main {\n  margin-left: 22%;\n  margin-right: 2%;\n  margin-top: 14vh;\n  margin-bottom: 3vh;\n  min-height: calc(100vh - 15vh);\n  width: 76%;\n  z-index: 1000;\n  box-sizing: border-box;\n  padding: 0 0.5vw;\n}\n\n/* ─────────────────────────────────────────────────────\n   PAGE HEADER TEXT\n───────────────────────────────────────────────────── */\n\n.adv-page-header {\n  margin-bottom: 24px;\n}\n\n.adv-page-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 6px 0;\n  line-height: normal;\n}\n\n.adv-page-title-accent {\n  color: #48d1cc;\n}\n\n.adv-page-sub {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #777;\n  margin: 0;\n  line-height: normal;\n}\n\n/* ─────────────────────────────────────────────────────\n   FILTER TABS\n───────────────────────────────────────────────────── */\n\n.adv-filter-tabs {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  padding-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.adv-filter-tab {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  padding: 7px 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #777;\n  cursor: pointer;\n  text-transform: capitalize;\n  transition: all 0.2s ease;\n}\n\n.adv-filter-tab:hover {\n  color: #fff;\n  background: rgba(255,255,255,0.04);\n}\n\n.adv-filter-tab--active {\n  background-color: #3bb3ae;\n  color: #071414;\n  font-weight: 700;\n}\n\n/* ─────────────────────────────────────────────────────\n   STATUS BADGES\n───────────────────────────────────────────────────── */\n\n.adv-status {\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: capitalize;\n  padding: 3px 10px;\n  border-radius: 20px;\n  line-height: normal;\n}\n\n.adv-status--confirmed   { color: #48d1cc; background: rgba(72,209,204,0.12); }\n.adv-status--pending     { color: #f5c842; background: rgba(245,200,66,0.12); }\n.adv-status--in_progress { color: #ffd700; background: rgba(255,215,0,0.12); }\n.adv-status--completed   { color: #28a745; background: rgba(40,167,69,0.12); }\n.adv-status--cancelled   { color: #dc3545; background: rgba(220,53,69,0.12); }\n.adv-status--closed      { color: #20b2aa; background: rgba(32,178,170,0.12); }\n.adv-status--disputed    { color: #ff4500; background: rgba(255,69,0,0.12); }\n.adv-status--registered   { color: #48d1cc; background: rgba(72,209,204,0.12); }\n.adv-status--waitlisted   { color: #f5c842; background: rgba(245,200,66,0.12); }\n\n\n/* ─────────────────────────────────────────────────────\n   LIST & BOOKING CARDS (CustomerBookingsPage)\n───────────────────────────────────────────────────── */\n\n.adv-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.adv-booking-card {\n  display: flex;\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 16px;\n  gap: 16px;\n  align-items: center;\n  transition: border-color 0.2s ease;\n}\n\n.adv-booking-card:hover {\n  border-color: rgba(59, 179, 174, 0.3);\n}\n\n.adv-booking-card__img {\n  width: 96px;\n  height: 96px;\n  border-radius: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.adv-booking-card__body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.adv-booking-card__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 4px;\n}\n\n.adv-booking-card__name {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0;\n  line-height: normal;\n}\n\n.adv-booking-card__meta {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: #777;\n  margin: 2px 0;\n  line-height: normal;\n}\n\n.adv-booking-card__meta strong {\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.adv-booking-card__price {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #48d1cc;\n  margin-top: 6px;\n  line-height: normal;\n}\n\n.adv-booking-card__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 130px;\n  flex-shrink: 0;\n}\n\n/* ─────────────────────────────────────────────────────\n   REQUEST CARDS (ProviderBookingsInboxPage)\n───────────────────────────────────────────────────── */\n\n.adv-request-card {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: border-color 0.2s ease;\n}\n\n.adv-request-card:hover {\n  border-color: rgba(59, 179, 174, 0.3);\n}\n\n.adv-request-card__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.adv-request-card__customer {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.adv-request-card__avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.adv-request-card__name {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0 0 2px 0;\n  line-height: normal;\n}\n\n.adv-request-card__time {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #777;\n  line-height: normal;\n}\n\n.adv-request-card__detail-grid {\n  display: grid;\n  grid-template-columns: 1.8fr 1.2fr;\n  gap: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 16px;\n}\n\n.adv-request-card__left-col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.adv-request-card__meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.adv-meta-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: rgba(90, 175, 154, 0.08);\n  border: 1px solid rgba(90, 175, 154, 0.15);\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #5AAF9A;\n}\n\n.adv-meta-pill span {\n  font-size: 13px;\n}\n\n.adv-request-card__right-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  text-align: right;\n  min-height: 120px;\n}\n\n.adv-request-card__price-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.adv-price-title {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.adv-price-val {\n  font-size: 24px;\n  font-weight: 700;\n  color: #5AAF9A;\n}\n\n.adv-request-card__actions-row {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: auto;\n}\n\n/* ─────────────────────────────────────────────────────\n   DETAIL LABELS & TYPOGRAPHY\n───────────────────────────────────────────────────── */\n\n.adv-detail-label {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #777;\n  margin: 0 0 4px 0;\n  line-height: normal;\n}\n\n.adv-detail-value {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  line-height: normal;\n}\n\n.adv-detail-sub {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #777;\n  margin: 2px 0 0 0;\n  line-height: normal;\n}\n\n.adv-detail-link {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  color: #48d1cc;\n  cursor: pointer;\n  text-decoration: underline;\n  line-height: normal;\n}\n\n.adv-detail-notes {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #777;\n  background: rgba(0,0,0,0.15);\n  padding: 10px;\n  border-radius: 6px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* ─────────────────────────────────────────────────────\n   DETAIL PAGE LAYOUT (CustomerBookingDetailPage)\n───────────────────────────────────────────────────── */\n\n.adv-detail-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n}\n\n.adv-detail-grid {\n  display: grid;\n  grid-template-columns: 1.8fr 1.2fr;\n  gap: 24px;\n}\n\n.adv-detail-left,\n.adv-detail-right {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Cards used in detail page ── */\n.adv-card {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.adv-card--row {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.adv-card--col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.adv-card-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.adv-card-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 14px 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255,255,255,0.07);\n  line-height: normal;\n}\n\n.adv-detail-cover {\n  width: 100%;\n  height: 220px;\n  border-radius: 8px;\n  object-fit: cover;\n  margin-bottom: 16px;\n}\n\n.adv-detail-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 10px 0;\n  line-height: normal;\n}\n\n.adv-detail-meta-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.adv-detail-date-note {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #777;\n  line-height: normal;\n}\n\n/* ── Notes blocks ── */\n.adv-note-block {\n  background: rgba(0,0,0,0.2);\n  padding: 12px;\n  border-radius: 6px;\n}\n\n.adv-note-block--teal  { background: rgba(72,209,204,0.06); border: 1px solid rgba(72,209,204,0.15); }\n.adv-note-block--green { background: rgba(40,167,69,0.06); border: 1px solid rgba(40,167,69,0.15); }\n.adv-note-block--red   { background: rgba(255,107,107,0.06); border: 1px solid rgba(255,107,107,0.15); }\n.adv-note-block--yellow { background: rgba(255,215,0,0.06); border: 1px solid rgba(255,215,0,0.15); }\n\n.adv-note-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  color: #ffffff;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* ── Schedule rows ── */\n.adv-schedule-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adv-schedule-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.adv-schedule-divider {\n  border-top: 1px solid rgba(255,255,255,0.08);\n  margin: 4px 0;\n}\n\n.adv-schedule-price {\n  font-family: \"Inter\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: #48d1cc;\n  line-height: normal;\n}\n\n.adv-action-btns {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adv-btn--full { width: 100%; }\n\n.adv-waiting-note {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #777;\n  text-align: center;\n  background: rgba(255,255,255,0.03);\n  padding: 10px;\n  border-radius: 8px;\n  border: 1.5px solid rgba(255,255,255,0.07);\n}\n\n.adv-auto-release-note {\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  color: #777;\n  text-align: center;\n  font-style: italic;\n  margin: 0;\n}\n\n/* ── Timeline ── */\n.adv-timeline {\n  position: relative;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.adv-timeline__track {\n  position: absolute;\n  top: 10px;\n  bottom: 10px;\n  left: 4px;\n  width: 2px;\n  background-color: rgba(255,255,255,0.1);\n}\n\n.adv-timeline__item {\n  position: relative;\n}\n\n.adv-timeline__dot {\n  position: absolute;\n  left: -20px;\n  top: 4px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.adv-timeline__content {\n  display: flex;\n  flex-direction: column;\n}\n\n.adv-timeline__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.adv-timeline__status {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n  text-transform: capitalize;\n  line-height: normal;\n}\n\n.adv-timeline__actor {\n  font-family: \"Inter\", sans-serif;\n  font-size: 9px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: rgba(255,255,255,0.06);\n  color: #777;\n  text-transform: uppercase;\n}\n\n.adv-timeline__time {\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  color: #777;\n  margin-top: 2px;\n}\n\n.adv-timeline__note {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #777;\n  margin-top: 4px;\n}\n\n/* ── Evidence grid ── */\n.adv-evidence-grid {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.adv-evidence-img {\n  width: 80px;\n  height: 80px;\n  border-radius: 6px;\n  object-fit: cover;\n  border: 1px solid rgba(255,255,255,0.1);\n}\n\n.adv-evidence-remove {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background: #dc3545;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n  font-size: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n/* ─────────────────────────────────────────────────────\n   BUTTONS (shared)\n───────────────────────────────────────────────────── */\n\n.adv-btn-primary {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  background-color: #3bb3ae;\n  color: #071414;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  white-space: nowrap;\n  line-height: normal;\n}\n.adv-btn-primary:hover { opacity: 0.88; }\n\n.adv-btn-outline {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid #484848;\n  background: transparent;\n  color: #ffffff;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease;\n  white-space: nowrap;\n  line-height: normal;\n}\n.adv-btn-outline:hover { border-color: #48d1cc; color: #48d1cc; }\n\n.adv-btn-teal-outline {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid #48d1cc;\n  background: transparent;\n  color: #48d1cc;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n  line-height: normal;\n}\n.adv-btn-teal-outline:hover { background: rgba(72,209,204,0.08); }\n\n.adv-btn-danger-outline {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid rgba(255,107,107,0.4);\n  background: transparent;\n  color: #ff6b6b;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n  line-height: normal;\n}\n.adv-btn-danger-outline:hover { background: rgba(255,107,107,0.08); }\n\n.adv-btn-success {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  background-color: #28a745;\n  color: #fff;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  white-space: nowrap;\n  line-height: normal;\n}\n.adv-btn-success:hover { opacity: 0.88; }\n\n.adv-btn-destructive {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  background-color: #dc3545;\n  color: #fff;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  white-space: nowrap;\n  line-height: normal;\n}\n.adv-btn-destructive:hover { opacity: 0.88; }\n\n.adv-btn-ghost {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  background: rgba(255,255,255,0.08);\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n  line-height: normal;\n}\n.adv-btn-ghost:hover { background: rgba(255,255,255,0.12); }\n\n/* ─────────────────────────────────────────────────────\n   STATE MESSAGES\n───────────────────────────────────────────────────── */\n\n.adv-state-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #777;\n  padding: 60px 0;\n  text-align: center;\n  line-height: normal;\n}\n\n.adv-state-error {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  color: #ff6b6b;\n  padding: 40px;\n  text-align: center;\n  background: rgba(255,107,107,0.05);\n  border: 1px solid rgba(255,107,107,0.15);\n  border-radius: 12px;\n}\n\n.adv-empty {\n  font-family: \"Inter\", sans-serif;\n  background-color: #0e1b1b;\n  border: 1.5px dashed rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 40px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.adv-empty p {\n  font-size: 14px;\n  font-weight: 400;\n  color: #777;\n  margin: 0;\n  line-height: normal;\n}\n\n/* ─────────────────────────────────────────────────────\n   MODALS\n───────────────────────────────────────────────────── */\n\n.adv-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 110000;\n}\n\n.adv-modal {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 420px;\n  width: 100%;\n  margin: 20px;\n}\n\n.adv-modal__title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 8px 0;\n  line-height: normal;\n}\n\n.adv-modal__desc {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #777;\n  margin: 0 0 16px 0;\n  line-height: 1.5;\n}\n\n.adv-modal__field {\n  margin-bottom: 16px;\n}\n\n.adv-modal__label {\n  display: block;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #777;\n  margin-bottom: 8px;\n  line-height: normal;\n}\n\n.adv-modal__textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #484848;\n  background-color: rgba(0, 0, 0, 0.3);\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  resize: none;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n}\n\n.adv-modal__textarea:focus {\n  border-color: #3bb3ae;\n}\n\n.adv-modal__select {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #484848;\n  background-color: rgba(0, 0, 0, 0.3);\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n  color-scheme: dark;\n}\n\n.adv-modal__select:focus { border-color: #3bb3ae; }\n\n.adv-modal__select option {\n  background-color: #0e1b1b;\n  color: #ffffff;\n}\n\n.adv-modal__input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #484848;\n  background-color: rgba(0, 0, 0, 0.3);\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n  color-scheme: dark;\n}\n\n.adv-modal__input:focus {\n  border-color: #3bb3ae;\n}\n\n.adv-modal__warning {\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  color: #ff6b6b;\n  background: rgba(255,107,107,0.08);\n  padding: 10px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border: 1px solid rgba(255,107,107,0.15);\n  line-height: 1.5;\n}\n\n.adv-modal__actions,\n.adv-modal-actions {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.adv-modal__char-count {\n  display: block;\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  color: #777;\n  text-align: right;\n  margin-top: 4px;\n}\n\n.adv-uploading-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #48d1cc;\n}\n\n/* ─────────────────────────────────────────────────────\n   ANIMATION UTILITIES\n───────────────────────────────────────────────────── */\n\n@keyframes adv-fade-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.animate-fade-in {\n  animation: adv-fade-in 0.3s ease forwards;\n}\n\n/* ─────────────────────────────────────────────────────\n   RESPONSIVE\n───────────────────────────────────────────────────── */\n\n@media (max-width: 1024px) {\n  .adv-detail-grid { grid-template-columns: 1fr; }\n  .adv-request-card__detail-grid { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 768px) {\n  .adv-page-main {\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 80px;\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .sidebarContain { display: none; }\n\n  .adv-booking-card { flex-direction: column; align-items: flex-start; }\n  .adv-booking-card__actions { width: 100%; flex-direction: row; flex-wrap: wrap; justify-content: flex-end; }\n  .adv-detail-page-header { flex-direction: column; gap: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
